import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Table, Form, Modal } from 'react-bootstrap';

import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileDownload } from '@fortawesome/free-solid-svg-icons';

import * as Common from '../Common';
import Dialog from '../Dialog';
import '../../mcss/common.css';

import PrintView from './PrintView';
import TransactionComment from './TransactionComment';

function Payment_Approval(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);


    const [reqData, setReqData] = useState([]);
    const [docListData, setDocListData] = useState([]);
    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);

    const [payListData, setPayListData] = useState([]);
    const [reqTotalReceived, setReqTotalReceived] = useState(0);
    const [reqTotalReceivable, setReqTotalReceivable] = useState(0);

    const [reqPaymentFinal, setReqPaymentFinal] = useState(0);
    const [reqPaymentapproved, setReqPaymentApproved] = useState(0);

    const [remark, setRemark] = useState("");
    const [showConfirmBox, setShowConfirmBox] = useState(false);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'PAYAPROVE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {

                    Common.callApi(Common.apiInProgress, [sid, 'detail', props.srno], function (result1) {
                        let resp1 = JSON.parse(result1);
                        setReqData(resp1);
                        setReqPaymentFinal(resp1.req_paymentfinal);
                        setReqPaymentApproved(resp1.req_paymentapproved);
                        setDocListData(resp1.req_documentdetail);
                        setPayListData(resp1.req_paymentdetail);
                        let tvalue = 0;
                        if (resp1.req_paymentdetail.length > 0) {
                            let arr = resp1.req_paymentdetail;
                            for (var i = 0; i < arr.length; ++i) {
                                tvalue = tvalue * 1 + arr[i]["amnt"] * 1;
                            }
                            setReqTotalReceived(tvalue);
                        }
                        setReqTotalReceivable(
                            ((resp1.req_sellrate * resp1.req_quantity).toFixed(2) * 1 + resp1.req_tcs * 1 + resp1.req_gst * 1 + resp1.req_bankcharges * 1 + resp1.req_nostrocharges * 1).toFixed()
                        );
                    });
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    function btnBackClick() {
        props.callInProgress();
    }

    function btnDocumentView(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }

    function btnAddComment() {
        var object1 = {
            srno: props.srno,
            cmnt: remark
        }
        Common.callApi(Common.apiPaymentApprove, [sid, 'addcomment', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setRemark("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function btnUnlockPayment() {
        if (window.confirm('Are you sure to unlock the payment ?')) {
            Common.callApi(Common.apiPaymentApprove, [sid, 'unlockpayment', props.srno], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setReqPaymentFinal(0);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    function btnApprovePayment() {
        if (window.confirm('Are you sure to Approve the payment ? Payment once approved can not be rolled back.')) {
            Common.callApi(Common.apiPaymentApprove, [sid, 'approvepayment', props.srno], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    setReqPaymentApproved(1);
                    setMsgText(resp.msg);
                    setMsgBox(true);
                } else if (resp.err1 !== "") {
                    setMsgText(resp.err1);
                    setMsgBox(true);
                } else {
                    if (window.confirm(resp.err + ' Do you really want to approve DUPLICATE payment ? Payment once approved can not be rolled back.')) {
                        Common.callApi(Common.apiPaymentApprove, [sid, 'approvepaymentagain', props.srno], function (result) {
                            let resp = JSON.parse(result);
                            if (resp.err === "") {
                                setReqPaymentApproved(1);
                                setMsgText(resp.msg);
                                setMsgBox(true);
                            } else {
                                setMsgText(resp.err);
                                setMsgBox(true);
                            }
                        });
                    }
                }

            });
        }
    }
    const getMimeType = (ext) => {
        switch (ext.toLowerCase()) {
            case "pdf":
                return "application/pdf";
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };
    
    const openDocument = (resp) => {
        setDocumentToView(resp.url_path);
        setDocumentTypeToView(getMimeType(resp.doc_ext));
        setDocumentDescToView(resp.docm_desc);
        setDocumentNameToView(resp.doc_aws_path);
        setShowDocument(true);
    };


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1>In Progress/Payment Approval</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <PrintView rhdata={reqData}></PrintView>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h5>Document</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>Type</td>
                                        <td>Remark</td>
                                        <td>File Name</td>
                                         <td>Upload Timestamp</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docListData.map((res) =>
                                        <tr key={res.srno}>
                                            <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                            <td>{res.doc_remark}</td>
                                            <td>{res.doc_aws == 1 ? res.doc_aws_path.slice(10) : res.doc_filename}</td>
                                             <td>{res.doc_uploadedat}</td>
                                            <td>
                                                <div className="colorThemeBlue">
                                                    {
                                                       ( res.doc_aws != 1 && (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                            || res.doc_ext === "jpg" || res.doc_ext === "png") ) ? <>
                                                            <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>&nbsp;
                                                        </> : null
                                                    }


                                                    &nbsp;
                                                    {(res.doc_aws == 1 &&
                                                        (
                                                            res.doc_ext === "pdf" ||
                                                            res.doc_ext === "jpeg" ||
                                                            res.doc_ext === "gif" ||
                                                            res.doc_ext === "jpg" ||
                                                            res.doc_ext === "png" ||
                                                            res.doc_ext === "webp"
                                                        )) && (
                                                            <span
                                                                onClick={() => Common.viewUploadedDocument(res.doc_aws_path, sid,openDocument)}
                                                                className="pointer colorThemeBlue"
                                                            >
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                        )}

                                                    &nbsp;&nbsp;
                                                    {res.doc_aws == 1 ? (
                                                        <span className="handCursor" onClick={() => Common.downloadUploadedDocument(res.doc_aws_path, sid)}>
                                                            <FontAwesomeIcon icon={faFileDownload} />

                                                        </span>
                                                    ) :
                                                    <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                        <FontAwesomeIcon icon={faFileDownload} />
                                                    </span>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h5>Payment</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={
                                reqTotalReceived * 1 !== reqTotalReceivable * 1 ? "divDanger" : "divNormal"
                            }
                            >
                                Total Received : <b>{reqTotalReceived}</b>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>Bank</td>
                                        <td>Reference No</td>
                                        <td>Amount</td>
                                        <td>Date</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {payListData.map((res) =>
                                        <tr key={res.srno}>
                                            <td className='divHide'>{res.srno}</td>
                                            <td>{res.bank + ' : ' + res.banknm}</td>
                                            <td>{res.refno}</td>
                                            <td>{res.amnt}</td>
                                            <td>{(res.paydate).split('-').reverse().join('/')}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    {
                        reqPaymentapproved === "0" ?
                            <Row>
                                <Col xs={6}>
                                    <Form.Group >
                                        <Form.Label>Comment</Form.Label>
                                        <Form.Control type="text" placeholder="Comment" maxLength={100}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setRemark)}
                                            value={remark} autoComplete="off" />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                                    </Form.Group>
                                </Col>
                            </Row>
                            : null
                    }

                    <Row>
                        <Col>&nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;

                            {
                                (reqPaymentapproved === "0" && reqPaymentFinal === "1") ?
                                    <>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnApprovePayment()} >Approve</Button><span>&nbsp;</span>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnUnlockPayment()} >Unlock Payment</Button>
                                    </>
                                    : null
                            }

                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <TransactionComment srno={props.srno} rc={refreshCounter}></TransactionComment>
                        </Col>
                    </Row>
                </Container>
                <div>
                    <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                        {msgText}
                    </Dialog>
                </div>
                <Modal
                    show={showDocument}
                    onHide={() => setShowDocument(false)}
                    size="xl"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-custom-modal-styling-title">
                            {documentDescToView + " : " + documentNameToView}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                        {
                            /*
                            type="image/png" type="application/pdf"
                            width="100%" height="100%"
                            
                            <object data={documentToView} type={documentTypeToView} class="internal">
        
                            </object>
                            */
                        }
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}
export default Payment_Approval;